import { CardTypeCallToActions, ProductShortName } from '@app/enums/_index';

import { Injectable } from '@angular/core';
import { BannerInfoItem } from '@app/models/_index';
import { Factory } from './_factory';

/**
 * Create Filter Home Banner Item Factory used by the home component on the showing Home Banner information.
 * Creates instances of Filter Banner Item
 */
@Injectable({
  providedIn: 'root',
})
export class BannerInfoFactory implements Factory<BannerInfoItem> {
  filterBannerInfo: BannerInfoItem[] = [];

  /**
   * Call and build static Filter Banner Items array.
   * Do not add or remove items from this array.
   * Used as a read-only reference.
   */
  constructor() {
    this.build();
  }

  /**
   * Build static Filter Banner Item array
   */
  build(): void {
    this.filterBannerInfo.push(
      new BannerInfoItem(
        ProductShortName.BEYOND_CX,
        'BeyondCX',
        'Equipping contact center agents with the human skills needed for a digital world.',
        CardTypeCallToActions.LEARN_MORE,
        'beyond-cx',
        'beyond-cx-hero-banner.png'
      )
    );
    this.filterBannerInfo.push(
      new BannerInfoItem(
        ProductShortName.BEYOND,
        'Knowledge Without Limits',
        'Genesys professional and CX training for\nall levels and skills.'.replace(/\n/g, '<br>'),
        CardTypeCallToActions.GET_STARTED,
        'search',
        'default-hero-banner.png'
      )
    );
    this.filterBannerInfo.push(
      new BannerInfoItem(
        ProductShortName.AGENT_PLATFORM,
        'Agent Platform (AP) Training for Genesys Cloud',
        'Your continuous learning journey starts here.',
        CardTypeCallToActions.LEARN_MORE,
        'agent-platform',
        'agent-platform-hero-banner.png'
      )
    );
  }

  /**
   * Return immutable or copy of Filter Banner Info Items collection
   * @returns - a slice or copy of thes static collection
   */
  getCollection(): BannerInfoItem[] {
    if (this.filterBannerInfo && this.filterBannerInfo.length === 0) {
      this.build();
    }
    return this.filterBannerInfo.slice();
  }

  /**
   * Return immutable or copy of Banner Info item by subscription name slug
   * @param id - banner info id
   * @returns - returns a BannerInfoItem by banner name slug
   */
  getBannerInfo(id: string): BannerInfoItem {
    return this.getCollection().find((item: BannerInfoItem) => item.id === id);
  }
}
